/**
 * 派工單表單關聯配置
 * 表單ID: c625f5bb-d804-4b52-8d77-8b6f4640e24d
 */

import { FormRelationshipConfig } from '../relationship-types';

export const WorkOrderFormConfig: FormRelationshipConfig = {
  formId: 'c625f5bb-d804-4b52-8d77-8b6f4640e24d',
  formName: '派工單',
  description: '台康的派工單表單的欄位關聯配置',
  relationships: [
   
  ]
};